import { render } from "./ReginsterView.vue?vue&type=template&id=3f0084b4&scoped=true"
import script from "./ReginsterView.vue?vue&type=script&lang=js"
export * from "./ReginsterView.vue?vue&type=script&lang=js"

import "./ReginsterView.vue?vue&type=style&index=0&id=3f0084b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0084b4"]])

export default __exports__